import { Spinner, Center } from '@sequencehq/core-components'

import { useCustomerContactsRoot } from './useCustomerContacts.root'
import { CustomerContactsProvider } from '../communication/internal/CustomerContacts.domain.context'
import { ReactNode } from 'react'

export const CustomerContactsRoot = ({
  children,
  customerId
}: {
  children: ReactNode
  customerId?: string
  alwaysRenderChildren?: boolean
}) => {
  const { customerContactsContext, ready } = useCustomerContactsRoot(customerId)

  if (!ready) {
    return (
      <Center height="100%" width="100%">
        <Spinner />
      </Center>
    )
  }

  return (
    <CustomerContactsProvider value={customerContactsContext}>
      {children}
    </CustomerContactsProvider>
  )
}
